import { Badge } from '@/components/ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import type { McpCoverageRoute } from '../types';

/** Больше строк браузер рисует заметно медленно — показываем первые N после фильтра. */
const MAX_ROWS = 500;

/** Права роута: группы через «И», внутри группы через «или». */
function formatPermissions(groups: string[][]): string {
  if (groups.length === 0) {
    return '—';
  }
  return groups.map((group) => group.join(' или ')).join(' и ');
}

/** Таблица строк отчёта покрытия. */
export function CoverageRoutesTable({ routes }: { routes: McpCoverageRoute[] }) {
  const visible = routes.slice(0, MAX_ROWS);

  return (
    <div className="space-y-2">
      <div className="overflow-x-auto rounded-md border">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Метод</TableHead>
              <TableHead>Путь</TableHead>
              <TableHead>Инструмент</TableHead>
              <TableHead>Аудитория</TableHead>
              <TableHead>Права</TableHead>
              <TableHead>Тело</TableHead>
              <TableHead>Query</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {visible.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} className="py-8 text-center text-muted-foreground">
                  Ничего не найдено
                </TableCell>
              </TableRow>
            ) : (
              visible.map((route) => (
                <TableRow key={`${route.method} ${route.path}`}>
                  <TableCell className="font-mono text-xs">{route.method}</TableCell>
                  <TableCell className="font-mono text-xs">{route.path}</TableCell>
                  <TableCell className="text-xs">
                    {route.toolName ? (
                      <span className="font-mono">{route.toolName}</span>
                    ) : (
                      <Badge variant="outline" className="font-normal">
                        {route.excluded ?? 'исключён'}
                      </Badge>
                    )}
                  </TableCell>
                  <TableCell className="text-xs">{route.audience}</TableCell>
                  <TableCell className="max-w-xs text-xs">{formatPermissions(route.requiredPermissions)}</TableCell>
                  <TableCell className="text-xs">
                    <span className={route.missingBodySchema ? 'text-destructive' : undefined}>{route.bodySource}</span>
                  </TableCell>
                  <TableCell className="text-xs">{route.querySource}</TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </div>
      {routes.length > MAX_ROWS ? (
        <p className="text-xs text-muted-foreground">
          Показаны первые {MAX_ROWS} из {routes.length} — уточните фильтр.
        </p>
      ) : null}
    </div>
  );
}
